(() => {
  const initGuide = (guide) => {
    if (guide.dataset.llGuideReady === 'true') return;
    guide.dataset.llGuideReady = 'true';

    guide.addEventListener('click', (event) => {
      const scrollButton = event.target.closest('[data-scroll-target]');
      if (scrollButton && guide.contains(scrollButton)) {
        const targetId = scrollButton.getAttribute('data-scroll-target');
        const target = targetId ? document.getElementById(targetId) : null;
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      const question = event.target.closest('.ll-faq__question');
      if (question && guide.contains(question)) {
        const isOpen = question.getAttribute('aria-expanded') === 'true';
        question.setAttribute('aria-expanded', String(!isOpen));
      }
    });
  };

  const initAllGuides = (root = document) => {
    root.querySelectorAll('[data-ll-buying-guide]').forEach(initGuide);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllGuides());
  } else {
    initAllGuides();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllGuides(event.target);
  });
})();
